import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, domainVal, DateFormatter, i18n } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import MicroCategorieActions from './microCaterogieActions';
import { AppConstants } from '../../constants/AppConstants';
import { isNullOrUndefined } from 'util';

class MicroCategorieTable extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MicroCategorieTable.jsx] ';
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            { field: 'descrizione', title: i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione'), sortable: 'true' },
            { field: 'idCategoriaProdotto', title: i18n('ARM_CORE_PRODUCT.SHARED.CATEGORIA_PRODOTTO', 'Categoria Prodotto'), sortable: 'true', formatter: this.categoriaProdottoFormatter },
            { field: 'codQuestionarioQuotazione', title: i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QST_QUOTAZIONE', 'Qst Quotazione'), sortable: 'true' },
            { field: 'codQuestionarioEmissione', title: i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QST_EMISSIONE', 'Qst Emissione'), sortable: 'true' },
            { field: 'insertDate', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento'), formatter: this.dateFormatter, sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== undefined && nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === undefined || null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    categoriaProdottoFormatter(value, row, index) {

        console.log("categoriaProdottoFormatter:" + index);
        if (!isNullOrUndefined(row) && !isNullOrUndefined(row.categoriaProdotto)) {
            return row.categoriaProdotto.nome;

        }
        return '-'
    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    columnDetail(value, row, index) {
        console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/microCategorie/details', state: { id: row.id } });
    }


    render() {
        console.log(this.componentName + ' render');
        return (
            <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
    }
};

function mapStateToProps(state) {
    return {
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(MicroCategorieTable);
